// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.

import { createConsumer,logger } from "@rails/actioncable"

// import * as ActionCable from '@rails/actioncable'
// logger.enabled = true
export default createConsumer()
